export { default } from './publications-page-header';
